import { string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { PRODUCT_BANNER_TYPES } from 'constants/banners';

import LiveBanners from './LiveBanners';

// Aligns the Ask an HR Expert banners with the padding of the My Cases page
// container below them, which adds the remaining 1rem of the gap to the nav.
const AskAProLiveBanners = styled(LiveBanners)`
    padding: 1rem 3.5rem 0;
    margin-bottom: 0.5rem;

    ${({ theme }) => theme.media.down('md')`
        padding: 1rem 1rem 0;
    `};
`;

// The handbooks library renders its banners flush with the top of the page.
const HandbookLiveBanners = styled(LiveBanners)`
    padding: 16px 16px 0 16px;
`;

/**
 * The routes that render banners, and the banners they render. Each entry maps
 * the pathnames of a page to the banners shown above it.
 *
 * @type {Object[]}
 */
export const ROUTE_BANNERS = [
    {
        paths: ['/my-cases/create', '/my-cases/client-cases/create'],
        render: () => <AskAProLiveBanners product={PRODUCT_BANNER_TYPES.ASK_A_PRO} />,
    },
    {
        paths: ['/company-policies/handbooks/list'],
        render: () => <HandbookLiveBanners product={PRODUCT_BANNER_TYPES.HANDBOOKS} />,
    },
];

/**
 * Renders the banners configured for the current route, if any. Kept out of the
 * page containers themselves so the pages don't need to know about banners.
 *
 * @param  {Object} props The props for the component.
 * @return {JSX.Element|null}
 */
const RouteBanners = ({ pathname }) => {
    const routeBanners = ROUTE_BANNERS.find(({ paths }) => paths.includes(pathname));

    return routeBanners ? routeBanners.render() : null;
};

RouteBanners.propTypes = {
    pathname: string,
};

RouteBanners.defaultProps = {
    pathname: '',
};

export default RouteBanners;
